import { Component } from '@angular/core';

import { ContentLoaderComponent } from './content-loader.component';

@Component({
    selector: 'jhi-list-content-loader',
    template: `
        <jhi-content-loader viewBox="0 0 400 110">
            <svg:rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
            <svg:rect x="20" y="20" rx="3" ry="3" width="220" height="10" />
            <svg:rect x="20" y="40" rx="3" ry="3" width="170" height="10" />
            <svg:rect x="0" y="60" rx="3" ry="3" width="250" height="10" />
            <svg:rect x="20" y="80" rx="3" ry="3" width="200" height="10" />
            <svg:rect x="20" y="100" rx="3" ry="3" width="80" height="10" />
        </jhi-content-loader>
    `
})
export class ListContentLoaderComponent extends ContentLoaderComponent {}
